import "./portfolio.css";
import "bootstrap/dist/css/bootstrap.min.css";
import topdealiimg from "./image/topdeal.png";
import orfarmimg from "./image/orfarm.png";
import portimg from "./image/portfolio.png";
import aratbimg from "./image/artab2024-03-24 at 6.36.11 PM.png";
import nvimg from "./image/webnv2024-03-24 at 6.38.47 PM.png";
import rusrtimg from "./image/webrust2024-03-24 at 6.41.35 PM.png";
import portfolio12 from "./image/our-portfolio.png";
import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";

function Portfolio() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <link
        rel="stylesheet"
        href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
      ></link>

      <img width="100%" src={portfolio12} className="img-fluid" alt="..." />

      <div class="container-fluid mt-5 mb-5">
        <div class="container">
          {/* <div class="row">
            <div className="col-lg-4">
              <div className="portfolio">
                <img src={portimg} style={{ width: "100%" }} alt=""></img>
                <h2>Portfolio Website Developement</h2>
                <h5>
                  <Link
                    className="btn btn-primary"
                    to="https://dancing-biscuit-0ee7dd.netlify.app"
                  >
                    Visit Website
                  </Link>
                </h5>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="portfolio">
                <img src={topdealiimg} style={{ width: "100%" }} alt=""></img>
                <h2>Top-Deals Ecommerce</h2>
                <h5>
                  <Link
                    className="btn btn-primary"
                    to="https://rupali123r.github.io/Top-Deals/"
                  >
                    Visit Website
                  </Link>
                </h5>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="portfolio">
                <img src={orfarmimg} style={{ width: "100%" }} alt=""></img>
                <h2>Orfarm ECommerce</h2>
                <h5>
                  <Link
                    className="btn btn-primary"
                    to="https://rupali123r.github.io/Orfarm_Website_fullResponsive/"
                  >
                    Visitt Website
                  </Link>
                </h5>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="portfolio">
                <img src={aratbimg} style={{ width: "100%" }} alt=""></img>
                <h2>Aratb Property Booking Site</h2>
                <h5>
                  <Link className="btn btn-primary" to="https://aratb.com/">
                    Visit Website
                  </Link>
                </h5>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="portfolio">
                <img src={nvimg} style={{ width: "100%" }} alt=""></img>
                <h2>NVsparkle ECommerce</h2>
                <h5>
                  <Link className="btn btn-primary" to="https://nvsparkle.com/">
                    Visit Website
                  </Link>
                </h5>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="portfolio">
                <img src={rusrtimg} style={{ width: "100%" }} alt=""></img>
                <h2>Rust Console Community Social-Media</h2>
                <h5>
                  <Link
                    className="btn btn-primary"
                    to="https://rust-consolecommunity.com"
                  >
                    Visit Website
                  </Link>
                </h5>
              </div>
            </div>
          </div> */}
          <div className="row">
            <div className="col-lg-12 vlog">
              <h1 data-aos="fade-up" className="recent-title text-center">
                Our Recent Projects
              </h1>
            </div>
            <div className="col-lg-4">
              <div className="card">
                <img src={portimg} alt="" />
                <div className="card__content">
                  <h2
                    className="head_name "
                    style={{
                      fontSize: 25,
                      color: "red",
                      fontFamily: "sans-serif",
                    }}
                  >
                    Portfolio Website Developement
                  </h2>

                  <Link
                    className="btn btn-primary"
                    to="https://dancing-biscuit-0ee7dd.netlify.app"
                  >
                    Visit Website
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card">
                <img src={aratbimg} alt="" />
                <div className="card__content">
                  <h2
                    style={{
                      fontSize: 25,
                      color: "red",
                      fontFamily: "sans-serif",
                    }}
                  >
                    Aratb Property Booking Site
                  </h2>

                  <Link className="btn btn-primary" to="https://aratb.com/">
                    Visit Website
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card">
                <img src={topdealiimg} alt="" />
                <div className="card__content">
                  <h2
                    style={{
                      fontSize: 25,
                      color: "red",
                      fontFamily: "sans-serif",
                    }}
                  >
                    Top-Deals Ecommerce
                  </h2>
                  <Link
                    className="btn "
                    to="https://rupali123r.github.io/Top-Deals/"
                  >
                    Visit Website
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card">
                <img src={orfarmimg} alt="" />
                <div className="card__content">
                  <h2
                    style={{
                      fontSize: 25,
                      color: "red",
                      fontFamily: "sans-serif",
                    }}
                  >
                    Orfarm ECommerce
                  </h2>
                  <Link
                    className="btn btn-primary"
                    to="https://rupali123r.github.io/Orfarm_Website_fullResponsive/"
                  >
                    Visit Website
                  </Link>
                </div>
              </div>
            </div>
            
            <div className="col-lg-4">
              <div className="card">
                <img src={nvimg} alt="" />
                <div className="card__content">
                  <h2
                    style={{
                      fontSize: 25,
                      color: "red",
                      fontFamily: "sans-serif",
                    }}
                  >
                    NVsparkle ECommerce
                  </h2>

                  <Link className="btn btn-primary" to="https://nvsparkle.com/">
                    Visit Website
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card">
                <img src={rusrtimg} alt="" />
                <div className="card__content">
                  <h2
                    style={{
                      fontSize: 25,
                      color: "red",
                      fontFamily: "sans-serif",
                    }}
                  >
                    Rust Console Community Social-Media
                  </h2>
                  <Link
                    className="btn btn-primary"
                    to="https://rust-consolecommunity.com"
                  >
                    Visit Website
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Portfolio;
